module.exports = __webpack_public_path__ + "img/Umicore.c51af8c2.jpg";